var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ai-enroll"},[_c('div',[_c('activity',{attrs:{"content":_vm.message}})],1),_c('footer-layer',[_c('user-agreement-modal'),_c('edit-footer')],1),_c('check-footer'),_c('user-agreement-content-modal'),_c('mask-layer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }